export const DAYS = [{ key: 'monday', label: 'M' }, { key: 'tuesday', label: 'T' }, { key: 'wednesday', label: 'W' }, { key: 'thursday', label: 'T' }, { key: 'friday', label: 'F' }, { key: 'saturday', label: 'S' }, { key: 'sunday', label: 'S' }];

export const dataTypes = ['string', 'integer', 'decimal', 'boolean', 'date'];

export const dateFormat = 'MMMM dd, yyyy';
export const dateMaskFormat = '__/__/____';
export const dateTimeFormat = 'MMMM dd, yyyy hh:mm a z';